import Repository from './Repository';

const TRANSACTION = '/transaction';

export default {
	getTransaction() {
		return Repository.get(`${TRANSACTION}`);
	},
};
